import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-conferma',
  templateUrl: './reset-password-conferma.component.html',
  styleUrls: ['./reset-password-conferma.component.css']
})
export class ResetPasswordConfermaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
